/**
 * Shared constants for order-client-embedded lists
 * Note: No client fields in requiredFields (embedded in client context)
 */

/**
 * Standard required fields for all order-client-embedded lists
 */
export const ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS = [
	'_id',
	'externalId',
	'externalId2',
	'date',
	'_modified_date',
	'status',
	'origin',
	'numberOfLines',
	'assignedRepName',
	'submitterName',
	'tax',
	'freight',
	'discount',
	'discountType',
	'subtotal',
	'total',
	'totalGP',
	'companyName',
];
